import { FromTo } from '../Filters/types'

export type DateRangeType = FromTo<Date>
